'use strict';

module.exports = /*@ngInject*/ function (){
    var _environments = {
        local: {
            host: ['l', 'localhost', 'vm'],
            config: {
                secureCookies: false
            }
        },
        prod: {
            host: ['21net.com', 'nomadrail.com'],
            config: {
                secureCookies: true
            }
        }
    }, _environment;

    this.getEnvironment = function (){
        var host = window.location.hostname;
        if (_environment) {
            return _environment;
        }
        for (var environment in _environments){
            if (typeof(_environments[environment].host) && typeof(_environments[environment].host) == 'object') {
                for (var i = 0; i < _environments[environment].host.length; i++) {
                    if (host.includes(_environments[environment].host[i])) {
                        _environment = environment;
                        return _environment;
                    }
                }
            } else {
                if (typeof(_environments[environment].host) && host.endsWith(_environments[environment].host)) {
                    _environment = environment;
                    return _environment;
                }
            }
        }
        return null;
    };
    this.get = function (property) {
        return _environments[this.getEnvironment()].config[property];
    };
};

